export default __webpack_public_path__ + "static/media/elroq.0a04b062.png";